import type { ActionOutcome } from "../ui/ActionConfirmation.js";
import { formatDate } from "../format.js";
import type { StaffScheduleBlock } from "./scheduleBlocks.js";

/** Only the authoritative returned schedule state can prove creation/removal. */
export function scheduleBlockOutcome(block: StaffScheduleBlock, title: string, removal = false): ActionOutcome {
  const confirmed = removal ? block.status === "removed" : block.status === "active";
  const dates = block.block_date === block.end_date ? formatDate(block.block_date) : `${formatDate(block.block_date)}–${formatDate(block.end_date)}`;
  const times = block.start_time === null ? "All day" : `${block.start_time.slice(0, 5)}–${block.end_time?.slice(0, 5)}`;
  return {
    variant: confirmed ? "success" : "uncertain",
    title: confirmed ? title : removal ? "Blocked time removal needs checking" : "Blocked time needs checking",
    description: `${dates} · ${times}`,
    details: [
      { label: "Reason", value: block.reason },
      { value: confirmed
        ? removal ? "This block no longer prevents new bookings." : "Existing booked lessons were not changed."
        : "The booking system's schedule could not be confirmed. Check the schedule and Needs review before trying again." },
    ],
  };
}
